module.exports = __webpack_public_path__ + "img/standing-lamp.3eaa3f04.svg";